import { css } from "../helpers/webComponents";

export const characterStyles: string = css`
  
    :host {
        font-family: "Onesize";
        width: 100%;
        height: 100vh;
        display: grid;
        overflow: hidden;
    }

    .header {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: 0;
    }

    .header img {
        width: 100%;
        height: 100%;
        opacity: 100%;
        object-fit: cover;
        image-rendering: pixelated;
    }

    .title, .character-content {
        position: absolute;
        width: 80%;
        z-index: 1;
    }

    .character-content {
       position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        height: fit-content;
        align-items: center;
        bottom: 60%;
    }

    .character-content .button {
        padding: 5px 10px;
        text-transform: uppercase;
        cursor: pointer;
        user-select: none;
        color: #fff;
    }

    .character-footer {
        border-radius: 10px 10px 0 0;
        margin: 10px 15px 0 15px;
        display: flex;
        height: auto;
        justify-content: flex-start;
        align-items: center;
    }

    .character-footer .buttons {
        display: flex;
        flex-direction: row;
        gap: 30px;
        align-items: flex-start; 
        margin: 10px;
    } 

    .character-footer .buttons img {
        width: 100%;
        height: 100%;
        opacity: 100%;
        object-fit: cover;
        image-rendering: pixelated;
    }

    .character-footer .button {
        padding: 50px 50px;
        margin: 5px 0; 
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        color: white;
        border: 3px #3B4B62 solid;
        border-radius: 10px;
        background-color: #3B4B62;
    }

    .character-footer .button.active,
    .character-footer .button:hover {
        background-color: #fff9;
    }

    .footer .button, 
.character-footer .button, 
.startfooter .button {
    display: flex;
    align-items: center;
    gap: 5px; /* spacing between the image and text */
}

.action-image {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
}

`;

export class CharacterComponent extends HTMLElement {
    private isOpen: boolean = false;

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.render();
    }

    public toggle(): void {
        this.isOpen = !this.isOpen;
        this.style.display = this.isOpen ? "flex" : "none";
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
            <style>
            ${characterStyles}
            </style>
        `;
    }
}
